import { render } from "./ChiSiamoView.vue?vue&type=template&id=77a418b6&scoped=true"
import script from "./ChiSiamoView.vue?vue&type=script&lang=js"
export * from "./ChiSiamoView.vue?vue&type=script&lang=js"

import "./ChiSiamoView.vue?vue&type=style&index=0&id=77a418b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a418b6"]])

export default __exports__